import type { useScoreCorrection } from './use-score-correction'
import { useTranslation } from 'react-i18next'
import { formatPercent } from '../score-format'

/** L'historique des corrections d'un suivi (#161), en vigueur comme closes. */
function ScoreCorrectionHistory({ history }: { history: ReturnType<typeof useScoreCorrection>['history'] }) {
  const { t, i18n } = useTranslation()
  const date = (value: Date) => new Date(value).toLocaleString(i18n.language, { dateStyle: 'medium', timeStyle: 'short' })

  if (history.length === 0) return <p className="text-sm text-muted-foreground">{t('scoreCorrection.noHistory')}</p>
  return (
    <ol className="flex flex-col gap-3">
      {history.map(entry => (
        <li key={entry.id} className="rounded-md border border-border p-3 text-sm">
          <p className="font-medium">
            {t('scoreCorrection.entry', { from: formatPercent(entry.previousScore), to: formatPercent(entry.score) })}
          </p>
          <p className="text-muted-foreground">
            {t('scoreCorrection.by', { who: entry.correctedBy ?? t('scoreCorrection.deletedAccount'), when: date(entry.createdAt) })}
          </p>
          <p className="mt-1 whitespace-pre-wrap">{entry.reason}</p>
          {entry.revokedAt && (
            <p className="mt-1 text-xs text-muted-foreground">
              {t('scoreCorrection.ended', { who: entry.revokedBy ?? t('scoreCorrection.deletedAccount'), when: date(entry.revokedAt) })}
            </p>
          )}
        </li>
      ))}
    </ol>
  )
}

export default ScoreCorrectionHistory
